package raw.models



import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class OwnedCard(
    val id: String,

    // The specific config for this piece of plastic
    val network: String? = null,

    /**
     * Tracks usage of specific caps for THIS card only.
     * Key: The cap reference from cards.json (e.g., "smartbuy_monthly")
     * Value: Amount used so far (e.g., 12500.0)
     */
    val capUsage: Map<String, Double> = emptyMap(),

    /**
     * Tracks progress toward spend milestones for THIS card only.
     * Key: Milestone ID (e.g., "annual_fee_waiver_1L")
     * Value: Spend accumulated toward this goal (e.g., 45000.0)
     */
    val milestoneProgress: Map<String, Double> = emptyMap()
)

@Serializable
data class UserState(
    /**
     * Total overall spend across all cards. Useful for a generic dashboard widget.
     */
    val currentMonthSpend: Double = 0.0,

    /**
     * The user's digital wallet.
     * All card-specific state is encapsulated inside these objects.
     */
    @SerialName("owned_cards") val ownedCards: List<OwnedCard> = emptyList()
)